import { useMemo } from 'react';
import type { FunnelStage, Lead } from '../../../types';
import { computePipelineSummary, type PipelineSummary } from '../lib/pipelineSummary';

export function usePipelineSummary(
  leads: Lead[],
  stages: FunnelStage[],
): PipelineSummary {
  return useMemo(
    () => computePipelineSummary(leads, stages),
    [leads, stages],
  );
}
